import { initExpandsets } from './lib/expandset.js';
import { initModals } from './lib/modal.js';
import { initPageHeader } from './lib/page-header.js';
import { initTabsets } from './lib/tabset.js';
// import { initSwiper } from './lib/swiper';

initExpandsets();
initModals();
initTabsets();
initPageHeader(document.getElementById('page-header'));

// initSwiper();
